import React from 'react'
import { Navigate } from 'react-router-dom'

/** @deprecated Use /platform-console */
export function PlatformTenants() {
  return <Navigate to="/platform-console" replace />
}

export default PlatformTenants